import { forwardRef, ReactNode, type ComponentProps } from 'react';
import { SsnInput } from '../../atoms/ssn-input.component';
import { FieldLayoutWithAction } from '../../layouts/field-layout-with-action';
import type { BasicFormFieldProps, ExtraFieldProps, FieldActionProps } from '../../layouts/types';

type Props = BasicFormFieldProps<'ssn'> &
  ExtraFieldProps &
  FieldActionProps & {
    autoFocus?: boolean;
    endAdornment?: ReactNode;
  };

export const SsnField = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <FieldLayoutWithAction
    {...props}
    //TODO: this might be able to be improved. But this type cast just makes sure the field prop is any of the correct field types
    field={SsnInput as ComponentProps<typeof FieldLayoutWithAction>['field']}
    ref={ref}
  />
));

SsnField.displayName = 'SsnField';
